import React, {
  createContext,
  useContext,
  ReactNode,
  useEffect,
  useCallback,
  useRef,
} from "react";

interface ShortkeysContextType {
  setCommandZ: (fn: () => void, timeoutMs?: number) => void;
}

const ShortkeysContext = createContext<ShortkeysContextType | undefined>(
  undefined
);

export const ShortkeysProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  // useRef kullanarak fonksiyonu saklayalım
  const commandZRef = useRef<() => void>(() => {});

  const setCommandZ = useCallback((fn: () => void, timeoutMs = 5000) => {
    commandZRef.current = fn;
    if (timeoutMs > 0) {
      setTimeout(() => {
        commandZRef.current = () => {};
      }, timeoutMs);
    }
  }, []);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key === "z") {
        event.preventDefault();
        // Ref'ten fonksiyonu çağıralım
        commandZRef.current();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const value = {
    setCommandZ,
  };

  return (
    <ShortkeysContext.Provider value={value}>
      {children}
    </ShortkeysContext.Provider>
  );
};

export const useShortkeys = () => {
  const context = useContext(ShortkeysContext);
  if (context === undefined) {
    throw new Error("useShortkeys must be used within a ShortkeysProvider");
  }
  return context;
};
